<div class="page-container">
  <div class="page-header">
    <h1>Bank Management</h1>
  </div>

  <div class="card main-card mt-1-5">
    <h3 class="section-title mt-0">Connect Bank Account</h3>
    <p class="subtle mb-2">Securely link your bank account to automatically fetch statements and transactions via Plaid.</p>
    
    <button class="action-btn pdf-btn" (click)="connectBank()" [disabled]="isLoading">
      {{ isLoading ? 'Loading...' : 'Connect with Plaid' }}
    </button>
  </div>

  <!-- Placeholder for displaying connected accounts -->
  <div class="card main-card mt-1-5">
    <h3 class="section-title mt-0">Linked Accounts</h3>
    <table class="data-table">
      <thead>
        <tr>
          <th class="text-left">Bank Name</th>
          <th class="text-left">Account Name</th>
          <th class="text-center">Mask</th>
          <th class="text-center">Status</th>
          <th class="text-center">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="isLoadingAccounts">
          <td colspan="5" class="empty-table-msg text-center">Loading accounts...</td>
        </tr>
        <tr *ngIf="!isLoadingAccounts && accounts.length === 0">
          <td colspan="5" class="empty-table-msg text-center">No bank accounts linked yet.</td>
        </tr>
        <tr *ngFor="let acc of accounts">
          <td class="text-left">Bank Inst. Linked</td>
          <td class="text-left">{{ acc.name }} ({{ acc.subtype }})</td>
          <td class="text-center">...{{ acc.mask }}</td>
          <td class="text-center">
            <span style="color: #10b981; font-weight: 600;">{{ acc.balances?.current | currency:(acc.balances?.iso_currency_code || 'USD') }}</span>
          </td>
          <td class="text-center">
            <button class="action-btn text-primary" style="background: none; border: none; cursor: pointer; text-decoration: underline;" (click)="getStatements(acc.account_id)">View Statements</button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
